import type { Service } from '@wix/ambassador-bookings-services-v2-service/types';
import { ActionFactoryParams } from '../../../../utilsDeprecated/ControlledComponent/ControlledComponent.types';
import { CalendarContext } from '../../../../utilsDeprecated/context/contextFactory';
import { CalendarStateDeprecated } from '../../controller';

export type OnPreferencesModalServiceSelected = (
  selectedService: Service,
) => Promise<void>;

export const createOnPreferencesModalServiceSelectedAction =
  ({
    getControllerState,
    context,
  }: ActionFactoryParams<
    CalendarStateDeprecated,
    CalendarContext
  >): OnPreferencesModalServiceSelected =>
  async (selectedService) => {
    const { onServiceSelected } = await import(
      '@wix/bookings-services-preferences-modal/controllerActions'
    );
    const [state, setState] = getControllerState();

    const { serviceVariantsMap } = state;
    const { flowAPI } = context;

    onServiceSelected({
      httpClient: flowAPI.httpClient,
      selectedService,
      getServicesPreferencesModalData: () =>
        getControllerState()[0].servicesPreferencesModalData!,
      setServicesPreferencesModalData: (data) => {
        setState({ servicesPreferencesModalData: data });
      },
      prefetchedData: { getServiceOptionsAndVariants: serviceVariantsMap },
    });
  };
